import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import cskincss from "../assets/cskinss.png";
import cskphincss from "../assets/cskphillips.png";
import woodincss from "../assets/woodinss.png";

const products = [
  {
    id: 1,
    name: "CSK Head",
    image: cskincss,
    specifications: [
      { label: "Material", value: "Stainless Steel" },
     
      
    ],
    sizeLength: [
      { size: "4 x", lengths: "13, 16, 19" },
      { size: "5 x", lengths: "16,19" },
      { size: "6 x", lengths: "16,19,25,32,38,45,50" },
      { size: "8 x", lengths: "13,16,19,25,32,38,45,50,60"},
      {size:"10 x", lengths: "25,32,38,60,75"},
      {size:"12x",lengths:"19,25"}
    ]
  },
  {
    id: 2,
    name: "CSK Phillips",
    image: cskphincss,
    specifications: [
      { label: "Material", value: "Stainless Steel " },
      
      
    ],
    sizeLength: [
      { size: "4 x", lengths: "13,16,19" },
      { size: "5 x", lengths: "16,19" },
      { size: "6 x", lengths: "16,19,25,32,38,45,50" },
      {size:"8x",lengths: "13,16,19,25,32,38,45,50,60"},
      {size:"10x",lengths:"25,32,38,60,75"},
      {size:"12x",lengths:"19,25"}
    ]
  },
  {
    id: 3,
    name: "Wood Screw",
    image: woodincss,
    specifications: [
      { label: "Material", value: "Stainless Steel " },
  
      
    ],
    sizeLength: [
      { size: "4 x", lengths: "12" },
      { size: "5 x", lengths: "15,20" },
      { size: "6 x", lengths: "15,20,25,30,35" },
      {size:"7x",lengths: "15,20,25,30,35"},
      {size:"8x",lengths:"25,30,35,50,60"},
    ]
  }
];

const SSScrew = () => {
  const navigate = useNavigate();
  const [selectedProduct, setSelectedProduct] = useState(null);

  return (
    <div className="p-8 min-h-screen bg-white text-gray-900">
      {/* Back Button */}
      <button
        onClick={() => navigate("/products")}
        className="bg-gradient-to-r from-blue-500 to-blue-700 text-white px-5 py-3 rounded-lg shadow-md hover:scale-105 transition-transform"
      >
        ⬅️ Back to Product Page
      </button>

      {/* Title */}
      <h2 className="text-4xl font-bold text-center my-10 text-gray-800">
        🛠️ Categories of SS Screw
      </h2>

      {/* Product Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 place-items-center">
        {products.map((product) => (
          <div
            key={product.id}
            className="border border-gray-300 bg-white shadow-lg p-6 rounded-xl hover:shadow-2xl transform transition duration-300 hover:scale-105 cursor-pointer"
            onClick={() => setSelectedProduct(product)}
          >
            <img src={product.image} alt={product.name} className="w-40 mx-auto" />
            <h3 className="text-lg font-bold text-center mt-4">{product.name}</h3>
          </div>
        ))}
      </div>

      {/* Product Details Modal */}
      {selectedProduct && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 flex items-center justify-center">
          <div className="bg-white p-6 rounded-lg shadow-xl max-w-lg w-full transform transition-all duration-300 scale-100">
            <h3 className="text-2xl font-bold text-center">{selectedProduct.name}</h3>
            <img src={selectedProduct.image} alt={selectedProduct.name} className="w-40 mx-auto my-4" />
            
            {/* Specifications */}
            <h4 className="text-lg font-semibold">📜 Specifications:</h4>
            <ul className="list-disc pl-6 text-gray-700">
              {selectedProduct.specifications.map((spec, index) => (
                <li key={index}><strong>{spec.label}:</strong> {spec.value}</li>
              ))}
            </ul>

            {/* Size & Length Table */}
            <h4 className="text-lg font-semibold mt-4">📏 Size & Length:</h4>
            <div className="overflow-x-auto">
              <table className="table-auto w-full border-collapse border border-gray-300 mt-2">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="border border-gray-300 px-4 py-2">Size</th>
                    <th className="border border-gray-300 px-4 py-2">Length</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedProduct.sizeLength.map((item, index) => (
                    <tr key={index} className="bg-white">
                      <td className="border border-gray-300 px-4 py-2">{item.size}</td>
                      <td className="border border-gray-300 px-4 py-2">{item.lengths}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Close Button */}
            <button
              className="mt-6 w-full py-3 bg-red-500 hover:bg-red-600 text-white rounded-lg transition-transform hover:scale-105"
              onClick={() => setSelectedProduct(null)}
            >
              ❌ Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SSScrew;
